import React from 'react';
export var ODSpace = function (props) {
    var v = props.v, h = props.h, minSize = props.minSize, children = props.children;
    var isVertical = v === true || h === false;
    if (isVertical) {
        return React.createElement("div", { style: { minHeight: minSize } }, children);
    }
    return React.createElement("div", { style: { minWidth: minSize } }, children);
};
//# sourceMappingURL=ODSpace.js.map